import DpitMultiStateAnimBtn from './DpitMultiStateAnimBtn';
import {
	wrapElementByContainer
} from '../../../../includes/assets/js/modules/dpitUtilsInc';

export const CLASSES = {
	adminBtn: 'dpit-admin-btn',
	adminBtnWrap: 'dpit-admin-btn-wrap'
};

export const IDS = {
	promoBtnWrap: 'dpit-promo-btn-wrap'
};

export default class DPProPromoButton {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT DPProPromoButton');
		this.config = config;
		const appendAfterSelectors = ['.acf-field[data-name="intro_enabled"', '.acf-field-group[data-name="intro_url_variables"]>.acf-label'];
		appendAfterSelectors.forEach((appendAfterSelector, idx) => {
			const toInsertAfterEl = document.querySelector(appendAfterSelector);
			if (toInsertAfterEl) {
				const promoBtn = new DpitMultiStateAnimBtn(
					this.onClick.bind(this),
					{ default: config.proCTAText },
					'default',
					CLASSES.adminBtn,
					[CLASSES.adminBtn + '--cta', CLASSES.adminBtn + '--xl']
				);

				const filledContainerEl = wrapElementByContainer(
					promoBtn.getButtonElement(),
					CLASSES.adminBtnWrap,
					IDS.promoBtnWrap + '-' + (idx + 1)

				);
				toInsertAfterEl.append(filledContainerEl);
			}
		});
	}

	onClick(args) {
		args.button.startAnimation(false, 1, () => {
			window.open(this.config.proDemoLink, '_blank');
		});

	}
}